export default {
    $newFashion:true,
}